import { useEffect, useState } from "react";
import { Palmtree, LayoutDashboard, Home, CalendarCheck, Star, Wallet, LogOut, ExternalLink, Globe, Waves, Download, TicketPercent, PackagePlus } from "lucide-react";

const NAV = [
  { id: "inicio", label: "Início", icon: LayoutDashboard },
  { id: "imoveis", label: "Imóveis", icon: Home },
  { id: "adicionais", label: "Adicionais", icon: PackagePlus },
  { id: "passeios", label: "Passeios", icon: Waves },
  { id: "cupons", label: "Cupons", icon: TicketPercent },
  { id: "reservas", label: "Reservas", icon: CalendarCheck },
  { id: "avaliacoes", label: "Avaliações", icon: Star },
  { id: "site", label: "Dados do site", icon: Globe },
  { id: "config", label: "Pagamentos", icon: Wallet },
  { id: "backups", label: "Backups", icon: Download },
];

const useScrollSpy = (ids, key) => {
  const [active, setActive] = useState(ids[0]);
  useEffect(() => {
    const onScroll = () => {
      const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;
      if (atBottom) return setActive(ids[ids.length - 1]);
      let cur = ids[0];
      ids.forEach((id) => { const el = document.getElementById(id); if (el && el.getBoundingClientRect().top <= window.innerHeight * 0.35) cur = id; });
      setActive(cur);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [ids, key]);
  useEffect(() => {
    document.querySelector(`[data-testid="nav-${active}-m"]`)?.scrollIntoView({ inline: "nearest", block: "nearest" });
  }, [active]);
  return [active, setActive];
};

const ids = NAV.map((n) => n.id);

export const AdminShell = ({ user, onLogout, counts, children }) => {
  const [active, setActive] = useScrollSpy(ids, 0);
  const go = (id) => { setTimeout(() => setActive(id), 700); setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 50); };

  const item = (n, mobile) => {
    const on = active === n.id;
    return (
      <button key={n.id} onClick={() => go(n.id)} data-testid={`nav-${n.id}${mobile ? "-m" : ""}`}
        className={mobile
          ? `shrink-0 flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-semibold transition-colors ${on ? "bg-[#0A66C2] text-white" : "bg-white text-slate-600 border border-slate-200"}`
          : `w-full flex items-center gap-3 px-4 py-2.5 rounded-2xl text-sm font-semibold transition-colors ${on ? "bg-[#0A66C2] text-white shadow-md shadow-blue-200" : "text-slate-600 hover:bg-white"}`}>
        <n.icon size={17} /> {n.label}
        {!mobile && counts[n.id] > 0 && <span className={`ml-auto text-[11px] px-2 rounded-full ${on ? "bg-white/20" : "bg-[#FFCC00] text-blue-900"}`}>{counts[n.id]}</span>}
      </button>
    );
  };

  return (
    <div className="min-h-screen bg-[#FBF8F3] text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }} data-testid="loque-admin">
      <aside className="hidden lg:flex fixed inset-y-0 left-0 w-64 flex-col p-5 border-r border-[#EDE6DA] bg-[#F6F0E6]">
        <a href="/" className="flex items-center gap-2 px-2 mb-8" data-testid="admin-logo">
          <div className="bg-[#0A66C2] p-2 rounded-xl"><Palmtree className="text-white w-5 h-5" /></div>
          <span className="text-xl font-extrabold text-[#0A66C2]">Se Hospede <span className="text-[#FFB800]">AKI</span></span>
        </a>
        <nav className="space-y-1">{NAV.map((n) => item(n, false))}</nav>
        <div className="mt-auto space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="w-full flex items-center gap-3 px-4 py-2.5 rounded-2xl text-sm font-semibold text-slate-600 hover:bg-white" data-testid="nav-view-site">
            <ExternalLink size={17} /> Ver site
          </a>

          <div className="pt-3 mt-2 border-t border-[#EDE6DA] flex items-center gap-2 px-2">
            <div className="h-8 w-8 rounded-full bg-[#FFCC00] text-blue-900 font-bold flex items-center justify-center text-sm shrink-0">{(user?.email || "?")[0].toUpperCase()}</div>
            <span className="text-xs text-slate-500 truncate flex-1">{user?.email}</span>
            <button onClick={onLogout} title="Sair" className="h-8 w-8 rounded-full flex items-center justify-center text-slate-400 hover:text-red-600 hover:bg-white" data-testid="logout-button"><LogOut size={15} /></button>
          </div>
        </div>
      </aside>

      <header className="lg:hidden sticky top-0 z-30 bg-[#FBF8F3]/90 backdrop-blur-md border-b border-[#EDE6DA]">
        <div className="flex items-center justify-between px-4 pt-3">
          <span className="flex items-center gap-2 text-lg font-extrabold text-[#0A66C2]"><Palmtree size={20} /> <span>Se Hospede <span className="text-[#FFB800]">AKI</span></span></span>
          <div className="flex items-center gap-1">

            <button onClick={onLogout} className="h-9 w-9 rounded-full flex items-center justify-center text-slate-500" data-testid="logout-button-m"><LogOut size={16} /></button>
          </div>
        </div>
        <nav className="flex gap-2 overflow-x-auto px-4 py-3">{NAV.map((n) => item(n, true))}</nav>
      </header>

      <main className="lg:pl-64">
        <div className="max-w-6xl mx-auto p-4 sm:p-6 lg:p-10 space-y-6">{children}</div>
      </main>
    </div>
  );
};
